var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorPageBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 310.191,
    viewBox: "0 0 1920 310.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17878",
    "data-name": "Group 17878",
    transform: "translate(1366)",
    opacity: 0.403
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17886",
    "data-name": "Group 17886",
    transform: "translate(-1366 117.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M327.337,88.465V65.727H313.668V88.465H297.481V53.292h-11.87V27H275.9V0H255.755V27h-9.712V53.292H234.532V21.672h-6.475V5.684H224.1V21.672H201.079v100.9H183.453V111.913H172.661v10.658H155.036V88.465H123.381V65.727H109.712V88.465h-.719v43.7H94.6v-25.58H77.338v25.58H62.95V53.292H51.8V27H10.791V53.292H0V192.206H343.524V88.465Z",
    transform: "translate(0)",
    fill: "#0a1f39"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 15.011,
    height: 8.577,
    transform: "translate(6.791 62.711)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 15.011,
    height: 8.577,
    transform: "translate(40.907 62.711)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 15.011,
    height: 8.577,
    transform: "translate(6.791 79.748)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 15.011,
    height: 8.577,
    transform: "translate(40.907 79.748)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 15.011,
    height: 8.577,
    transform: "translate(6.791 96.785)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 15.011,
    height: 8.577,
    transform: "translate(40.907 96.785)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 15.011,
    height: 8.577,
    transform: "translate(6.791 113.822)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 15.011,
    height: 8.577,
    transform: "translate(40.907 113.822)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 15.011,
    height: 8.577,
    transform: "translate(6.791 130.859)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 15.011,
    height: 8.577,
    transform: "translate(40.907 130.859)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 15.011,
    height: 8.577,
    transform: "translate(6.791 147.895)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 15.011,
    height: 8.577,
    transform: "translate(40.907 147.896)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 15.011,
    height: 8.577,
    transform: "translate(6.791 164.816)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 15.011,
    height: 8.577,
    transform: "translate(40.907 164.816)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 35.025,
    height: 4.289,
    transform: "translate(68.627 143.51)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 35.025,
    height: 4.289,
    transform: "translate(68.627 150.034)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 35.025,
    height: 4.289,
    transform: "translate(68.627 156.366)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 35.025,
    height: 4.289,
    transform: "translate(160.692 145.685)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 35.025,
    height: 4.289,
    transform: "translate(160.692 152.208)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 35.025,
    height: 4.289,
    transform: "translate(160.692 158.554)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 35.025,
    height: 4.289,
    transform: "translate(68.627 162.929)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 35.025,
    height: 4.289,
    transform: "translate(68.627 169.492)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 35.025,
    height: 4.289,
    transform: "translate(68.627 176.055)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 9.65,
    height: 12.509,
    transform: "translate(116.749 98.62)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 9.65,
    height: 12.509,
    transform: "translate(137.959 98.62)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 9.65,
    height: 12.509,
    transform: "translate(116.749 118.924)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 9.65,
    height: 12.509,
    transform: "translate(137.959 118.924)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 9.65,
    height: 12.509,
    transform: "translate(116.749 139.228)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 9.65,
    height: 12.509,
    transform: "translate(137.959 139.228)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 9.65,
    height: 12.509,
    transform: "translate(116.749 159.404)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 9.65,
    height: 12.509,
    transform: "translate(137.959 159.404)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 12.866,
    height: 16.44,
    transform: "translate(201.239 29.827)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 12.866,
    height: 16.44,
    transform: "translate(201.239 54.399)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 12.866,
    height: 16.44,
    transform: "translate(201.239 78.335)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 12.866,
    height: 16.44,
    transform: "translate(201.239 102.27)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 12.866,
    height: 16.44,
    transform: "translate(201.239 126.206)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 12.866,
    height: 16.44,
    transform: "translate(201.239 149.975)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 47.891,
    height: 13.938,
    transform: "translate(242.561 64.544)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 47.891,
    height: 13.938,
    transform: "translate(242.739 95.003)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 47.891,
    height: 13.938,
    transform: "translate(242.918 125.461)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 47.891,
    height: 13.938,
    transform: "translate(243.097 155.777)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 6.433,
    height: 13.581,
    transform: "translate(10.722 35.172)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 16.083,
    height: 20.729,
    transform: "translate(327.442 98.67)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 16.083,
    height: 20.729,
    transform: "translate(327.442 129.142)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 16.083,
    height: 20.729,
    transform: "translate(327.442 159.535)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M341.941,151.238h-2.459a1.723,1.723,0,1,0,0-3.442H319.564a1.723,1.723,0,0,0,0,3.442h2.459a1.723,1.723,0,1,0,0,3.442h-3.442a1.723,1.723,0,1,0,0,3.442H338.5a1.723,1.723,0,1,0,0-3.442h3.442a1.723,1.723,0,1,0,0-3.442Z",
    transform: "translate(-246.63 -134.198)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M587.941,272.238h-2.459a1.723,1.723,0,1,0,0-3.442H565.564a1.723,1.723,0,0,0,0,3.442h2.459a1.723,1.723,0,1,0,0,3.442h-3.442a1.723,1.723,0,1,0,0,3.442H584.5a1.723,1.723,0,1,0,0-3.442h3.442a1.723,1.723,0,1,0,0-3.442Z",
    transform: "translate(-404.174 -211.137)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1006.941,114.238h-2.459a1.723,1.723,0,1,0,0-3.442H984.565a1.723,1.723,0,0,0,0,3.442h2.459a1.723,1.723,0,1,0,0,3.442h-3.442a1.723,1.723,0,1,0,0,3.442H1003.5a1.723,1.723,0,0,0,0-3.442h3.442a1.723,1.723,0,1,0,0-3.442Z",
    transform: "translate(-672.466 -110.421)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M519.305,465.94c-.275.2-.425.311-.425.311A1.81,1.81,0,0,0,519.305,465.94Z",
    transform: "translate(-376.138 -336.885)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M520.235,466.88c-.275.2-.425.311-.425.311A1.815,1.815,0,0,0,520.235,466.88Z",
    transform: "translate(-376.733 -337.485)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M520.235,465.94c-.275.2-.425.311-.425.311A1.812,1.812,0,0,0,520.235,465.94Z",
    transform: "translate(-376.733 -336.885)",
    fill: "#ebfaff",
    opacity: 0.253
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17879",
    "data-name": "Group 17879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27-2",
    "data-name": "Path 27",
    d: "M527.9,142.666V106H505.851v36.669h-26.1V85.944H460.6v-42.4H444.94V0H412.455V43.545H396.792v42.4H378.228V34.95H367.786V9.167h-6.381V34.95H324.279V197.67H295.853V180.482h-17.4V197.67H250.025v-55H198.976V106H176.932v36.669h-1.16V213.14h-23.2V171.887H124.723V213.14h-23.2V85.944H83.535v-42.4H17.4v42.4H0V309.97H554v-167.3Z",
    fill: "#0a1f39"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-2",
    "data-name": "Rectangle 15",
    width: 24.207,
    height: 13.833,
    transform: "translate(10.951 101.133)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-2",
    "data-name": "Rectangle 16",
    width: 24.207,
    height: 13.833,
    transform: "translate(90.177 114.966) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-2",
    "data-name": "Rectangle 17",
    width: 24.207,
    height: 13.833,
    transform: "translate(10.951 128.609)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-2",
    "data-name": "Rectangle 18",
    width: 24.207,
    height: 13.833,
    transform: "translate(90.177 142.441) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19-2",
    "data-name": "Rectangle 19",
    width: 24.207,
    height: 13.833,
    transform: "translate(10.951 156.084)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20-2",
    "data-name": "Rectangle 20",
    width: 24.207,
    height: 13.833,
    transform: "translate(90.177 169.917) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-2",
    "data-name": "Rectangle 21",
    width: 24.207,
    height: 13.833,
    transform: "translate(10.951 183.56)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-2",
    "data-name": "Rectangle 22",
    width: 24.207,
    height: 13.833,
    transform: "translate(90.177 197.392) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-2",
    "data-name": "Rectangle 23",
    width: 24.207,
    height: 13.833,
    transform: "translate(10.951 211.035)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-2",
    "data-name": "Rectangle 24",
    width: 24.207,
    height: 13.833,
    transform: "translate(90.177 224.868) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-2",
    "data-name": "Rectangle 25",
    width: 24.207,
    height: 13.833,
    transform: "translate(10.951 238.51)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26-2",
    "data-name": "Rectangle 26",
    width: 24.207,
    height: 13.833,
    transform: "translate(90.177 252.344) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-2",
    "data-name": "Rectangle 27",
    width: 24.207,
    height: 13.833,
    transform: "translate(10.951 265.798)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28-2",
    "data-name": "Rectangle 28",
    width: 24.207,
    height: 13.833,
    transform: "translate(90.177 279.631) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29-2",
    "data-name": "Rectangle 29",
    width: 56.484,
    height: 6.916,
    transform: "translate(110.675 231.439)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-2",
    "data-name": "Rectangle 30",
    width: 56.484,
    height: 6.916,
    transform: "translate(110.675 241.959)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-2",
    "data-name": "Rectangle 31",
    width: 56.484,
    height: 6.916,
    transform: "translate(110.675 252.171)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-2",
    "data-name": "Rectangle 32",
    width: 56.484,
    height: 6.916,
    transform: "translate(259.148 234.946)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-2",
    "data-name": "Rectangle 33",
    width: 56.484,
    height: 6.916,
    transform: "translate(259.148 245.466)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34-2",
    "data-name": "Rectangle 34",
    width: 56.484,
    height: 6.916,
    transform: "translate(259.148 255.699)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35-2",
    "data-name": "Rectangle 35",
    width: 56.484,
    height: 6.916,
    transform: "translate(110.675 262.755)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36-2",
    "data-name": "Rectangle 36",
    width: 56.484,
    height: 6.916,
    transform: "translate(110.675 273.339)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37-2",
    "data-name": "Rectangle 37",
    width: 56.484,
    height: 6.916,
    transform: "translate(110.675 283.923)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38-2",
    "data-name": "Rectangle 38",
    width: 15.562,
    height: 20.173,
    transform: "translate(188.281 159.044)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39-2",
    "data-name": "Rectangle 39",
    width: 15.562,
    height: 20.173,
    transform: "translate(238.047 179.217) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40-2",
    "data-name": "Rectangle 40",
    width: 15.562,
    height: 20.173,
    transform: "translate(188.281 191.788)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41-2",
    "data-name": "Rectangle 41",
    width: 15.562,
    height: 20.173,
    transform: "translate(238.047 211.961) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42-2",
    "data-name": "Rectangle 42",
    width: 15.562,
    height: 20.173,
    transform: "translate(188.281 224.533)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43-2",
    "data-name": "Rectangle 43",
    width: 15.562,
    height: 20.173,
    transform: "translate(238.047 244.706) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44-2",
    "data-name": "Rectangle 44",
    width: 15.562,
    height: 20.173,
    transform: "translate(188.281 257.07)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45-2",
    "data-name": "Rectangle 45",
    width: 15.562,
    height: 20.173,
    transform: "translate(238.047 277.243) rotate(180)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46-2",
    "data-name": "Rectangle 46",
    width: 20.749,
    height: 26.513,
    transform: "translate(324.538 48.102)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47-2",
    "data-name": "Rectangle 47",
    width: 20.749,
    height: 26.513,
    transform: "translate(324.538 87.729)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48-2",
    "data-name": "Rectangle 48",
    width: 20.749,
    height: 26.513,
    transform: "translate(324.538 126.33)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49-2",
    "data-name": "Rectangle 49",
    width: 20.749,
    height: 26.513,
    transform: "translate(324.538 164.931)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50-2",
    "data-name": "Rectangle 50",
    width: 20.749,
    height: 26.513,
    transform: "translate(324.538 203.532)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51-2",
    "data-name": "Rectangle 51",
    width: 20.749,
    height: 26.513,
    transform: "translate(324.538 241.864)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52-2",
    "data-name": "Rectangle 52",
    width: 77.233,
    height: 22.478,
    transform: "translate(391.177 104.089)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53-2",
    "data-name": "Rectangle 53",
    width: 77.233,
    height: 22.478,
    transform: "translate(391.464 153.21)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54-2",
    "data-name": "Rectangle 54",
    width: 77.233,
    height: 22.478,
    transform: "translate(391.753 202.331)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55-2",
    "data-name": "Rectangle 55",
    width: 77.233,
    height: 22.478,
    transform: "translate(392.041 251.221)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56-2",
    "data-name": "Rectangle 56",
    width: 10.375,
    height: 21.902,
    transform: "translate(17.291 56.722)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57-2",
    "data-name": "Rectangle 57",
    width: 25.936,
    height: 33.429,
    transform: "translate(528.063 159.125)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58-2",
    "data-name": "Rectangle 58",
    width: 25.936,
    height: 33.429,
    transform: "translate(528.063 208.267)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59-2",
    "data-name": "Rectangle 59",
    width: 25.936,
    height: 33.429,
    transform: "translate(528.063 257.281)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-2",
    "data-name": "Path 28",
    d: "M357.356,153.348h-3.965a2.778,2.778,0,1,0,0-5.55H321.27a2.778,2.778,0,0,0,0,5.55h3.965a2.778,2.778,0,1,0,0,5.55h-5.55a2.778,2.778,0,1,0,0,5.55h32.121a2.778,2.778,0,1,0,0-5.55h5.55a2.778,2.778,0,1,0,0-5.55Z",
    transform: "translate(-203.649 -125.867)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    d: "M603.356,274.348h-3.965a2.778,2.778,0,1,0,0-5.55H567.27a2.778,2.778,0,0,0,0,5.55h3.965a2.778,2.778,0,1,0,0,5.55h-5.55a2.778,2.778,0,1,0,0,5.55h32.121a2.778,2.778,0,1,0,0-5.55h5.551a2.778,2.778,0,1,0,0-5.55Z",
    transform: "translate(-306.996 -175.81)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-2",
    "data-name": "Path 30",
    d: "M1022.356,116.348h-3.965a2.778,2.778,0,1,0,0-5.55H986.27a2.778,2.778,0,0,0,0,5.55h3.966a2.778,2.778,0,1,0,0,5.55h-5.551a2.778,2.778,0,1,0,0,5.55h32.121a2.778,2.778,0,0,0,0-5.55h5.55a2.778,2.778,0,1,0,0-5.55Z",
    transform: "translate(-482.95 -110.193)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-2",
    "data-name": "Path 31",
    d: "M519.566,465.94c-.444.323-.686.5-.686.5A2.919,2.919,0,0,0,519.566,465.94Z",
    transform: "translate(-288.681 -257.813)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-2",
    "data-name": "Path 32",
    d: "M520.5,466.88c-.444.323-.686.5-.686.5A2.926,2.926,0,0,0,520.5,466.88Z",
    transform: "translate(-289.072 -258.204)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    d: "M520.5,465.94c-.444.323-.686.5-.686.5A2.922,2.922,0,0,0,520.5,465.94Z",
    transform: "translate(-289.072 -257.813)",
    fill: "#ebfaff",
    opacity: 0.253
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(230.737 191.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-3",
    "data-name": "Path 29",
    d: "M158.443,584.947s-28.037,16.916,23.646,42.958c0,0,11.4-21.139-1.2-38.375a16.973,16.973,0,0,0-22.019-4.825Z",
    transform: "translate(-150.851 -510.668)",
    fill: "#01a09b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-3",
    "data-name": "Path 30",
    d: "M173.08,588.3s23.992,18.358,23.322,43.314",
    transform: "translate(-164.767 -514.377)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-3",
    "data-name": "Path 31",
    d: "M235.977,540.449s-8.785-29.828,1.649-51.783a47.1,47.1,0,0,0,3.81-29.558,79.239,79.239,0,0,0-4.184-13.889",
    transform: "translate(-202.93 -422.25)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-3",
    "data-name": "Path 32",
    d: "M240.057,394.062c0,3.657-6.62,14.245-6.62,14.245s-6.62-10.6-6.62-14.245a6.62,6.62,0,1,1,13.237,0Z",
    transform: "translate(-199.264 -387.289)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-3",
    "data-name": "Path 33",
    d: "M270.7,444.941c-1.987,3.07-13.3,8.369-13.3,8.369s.207-12.5,2.194-15.566a6.62,6.62,0,0,1,11.111,7.193Z",
    transform: "translate(-218.892 -417.58)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M265.008,537.683c-3.266,1.645-15.708.509-15.708.509s6.485-10.684,9.75-12.329a6.62,6.62,0,1,1,5.962,11.821Z",
    transform: "translate(-213.686 -475.1)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M248,612.037c-2.938,2.172-15.4,3.155-15.4,3.155s4.587-11.624,7.525-13.8A6.62,6.62,0,1,1,248,612.037Z",
    transform: "translate(-202.97 -522.763)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M214.54,467.9c2.621,2.546,14.839,5.185,14.839,5.185s-2.991-12.133-5.612-14.683a6.62,6.62,0,1,0-9.223,9.494Z",
    transform: "translate(-190.022 -431.32)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M192.32,551.973c3.266,1.645,15.708.509,15.708.509s-6.485-10.683-9.75-12.329a6.62,6.62,0,1,0-5.962,11.821Z",
    transform: "translate(-174.78 -484.194)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M186.6,639.2c2.938,2.172,15.4,3.155,15.4,3.155s-4.587-11.627-7.528-13.8A6.62,6.62,0,1,0,186.6,639.2Z",
    transform: "translate(-171.726 -539.459)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M240.057,394.062c0,3.657-6.62,14.245-6.62,14.245s-6.62-10.6-6.62-14.245a6.62,6.62,0,1,1,13.237,0Z",
    transform: "translate(-199.264 -387.289)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M270.7,444.941c-1.987,3.07-13.3,8.369-13.3,8.369s.207-12.5,2.194-15.566a6.62,6.62,0,0,1,11.111,7.193Z",
    transform: "translate(-218.892 -417.58)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M265.008,537.683c-3.266,1.645-15.708.509-15.708.509s6.485-10.684,9.75-12.329a6.62,6.62,0,1,1,5.962,11.821Z",
    transform: "translate(-213.686 -475.1)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M248,612.037c-2.938,2.172-15.4,3.155-15.4,3.155s4.587-11.624,7.525-13.8A6.62,6.62,0,1,1,248,612.037Z",
    transform: "translate(-202.97 -522.763)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M214.54,467.9c2.621,2.546,14.839,5.185,14.839,5.185s-2.991-12.133-5.612-14.683a6.62,6.62,0,1,0-9.223,9.494Z",
    transform: "translate(-190.022 -431.32)",
    fill: "#5ec5c1",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M192.32,551.973c3.266,1.645,15.708.509,15.708.509s-6.485-10.683-9.75-12.329a6.62,6.62,0,1,0-5.962,11.821Z",
    transform: "translate(-174.78 -484.194)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M186.6,639.2c2.938,2.172,15.4,3.155,15.4,3.155s-4.587-11.627-7.528-13.8A6.62,6.62,0,1,0,186.6,639.2Z",
    transform: "translate(-171.726 -539.459)",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(372.86 151.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M1007.187,550.746s-11.731-39.829,2.2-69.144a62.894,62.894,0,0,0,5.088-39.467,105.806,105.806,0,0,0-5.587-18.545",
    transform: "translate(-979.461 -392.696)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1014.587,374.7c0,4.883-8.84,19.02-8.84,19.02s-8.84-14.156-8.84-19.02a8.84,8.84,0,1,1,17.675,0Z",
    transform: "translate(-976.491 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M1045.215,426.281c-2.653,4.1-17.765,11.174-17.765,11.174s.276-16.686,2.929-20.784a8.84,8.84,0,1,1,14.836,9.605Z",
    transform: "translate(-992.511 -389.749)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1040.335,520.254c-4.36,2.2-20.975.68-20.975.68s8.659-14.265,13.019-16.462a8.839,8.839,0,1,1,7.961,15.784Z",
    transform: "translate(-988.268 -436.682)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M1023.221,594.411c-3.923,2.9-20.561,4.213-20.561,4.213s6.124-15.521,10.047-18.426a8.84,8.84,0,0,1,10.514,14.213Z",
    transform: "translate(-979.509 -475.201)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M985.463,450.255c3.5,3.4,19.814,6.924,19.814,6.924s-3.994-16.2-7.494-19.605a8.84,8.84,0,1,0-12.32,12.682Z",
    transform: "translate(-969.084 -401.418)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M963.855,534.655c4.36,2.2,20.975.68,20.975.68s-8.659-14.265-13.02-16.462a8.84,8.84,0,0,0-7.955,15.782Z",
    transform: "translate(-956.71 -444.144)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M957.557,621.571c3.923,2.9,20.561,4.213,20.561,4.213s-6.125-15.521-10.048-18.426a8.84,8.84,0,1,0-10.514,14.213Z",
    transform: "translate(-953.974 -489.173)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(210.104 206.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M901.3,621.986s7.643-25.937-1.435-45.037a40.975,40.975,0,0,1-3.314-25.706,68.925,68.925,0,0,1,3.637-12.063",
    transform: "translate(-882.489 -518.849)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M892.72,513.994c0,3.182,5.764,12.4,5.764,12.4s5.764-9.222,5.764-12.4a5.764,5.764,0,1,0-11.527,0Z",
    transform: "translate(-880.668 -508.23)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M910.223,542.091c1.729,2.669,11.573,7.28,11.573,7.28s-.178-10.87-1.908-13.539a5.764,5.764,0,1,0-9.666,6.259Z",
    transform: "translate(-907.687 -518.442)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M907.751,593.07c2.841,1.429,13.666.444,13.666.444s-5.643-9.291-8.478-10.72a5.764,5.764,0,0,0-5.187,10.282Z",
    transform: "translate(-904.8 -538.817)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M897.935,632.874c2.559,1.891,13.395,2.744,13.395,2.744s-3.989-10.109-6.547-12a5.764,5.764,0,0,0-6.847,9.256Z",
    transform: "translate(-889.538 -554.209)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M897.707,555.084c-2.305,2.213-12.9,4.513-12.9,4.513s2.6-10.553,4.882-12.767a5.764,5.764,0,1,1,8.023,8.259Z",
    transform: "translate(-871.512 -523.421)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M886.266,600.76c-2.842,1.429-13.666.444-13.666.444s5.643-9.291,8.478-10.72a5.764,5.764,0,0,1,5.187,10.282Z",
    transform: "translate(-854.042 -541.984)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M883.372,647.459c-2.559,1.891-13.395,2.743-13.395,2.743s4.011-10.115,6.547-12.006a5.764,5.764,0,0,1,6.847,9.262Z",
    transform: "translate(-848.842 -560.373)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(337.988 203.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-2",
    "data-name": "Path 46",
    d: "M1008.307,509.561s7.931-26.928-1.489-46.749a42.522,42.522,0,0,1-3.44-26.684,71.554,71.554,0,0,1,3.778-12.538",
    transform: "translate(-988.559 -402.702)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-2",
    "data-name": "Path 47",
    d: "M996.9,371.775c0,3.3,5.977,12.86,5.977,12.86s5.977-9.571,5.977-12.86a5.977,5.977,0,1,0-11.95,0Z",
    transform: "translate(-984.169 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-2",
    "data-name": "Path 48",
    d: "M1028.493,421.8c1.794,2.771,12.011,7.555,12.011,7.555s-.187-11.281-1.98-14.053a5.977,5.977,0,1,0-10.031,6.494Z",
    transform: "translate(-1025.634 -397.101)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-2",
    "data-name": "Path 49",
    d: "M1022.65,514.835c2.948,1.485,14.181.46,14.181.46s-5.855-9.645-8.8-11.13a5.976,5.976,0,1,0-5.382,10.672Z",
    transform: "translate(-1019.36 -458.331)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-2",
    "data-name": "Path 50",
    d: "M1005.083,589.245c2.652,1.961,13.9,2.849,13.9,2.849s-4.141-10.494-6.793-12.458a5.977,5.977,0,1,0-7.108,9.61Z",
    transform: "translate(-996.144 -508.647)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-2",
    "data-name": "Path 51",
    d: "M996.18,445.338c-2.366,2.3-13.4,4.681-13.4,4.681s2.7-10.953,5.067-13.255a5.977,5.977,0,1,1,8.33,8.574Z",
    transform: "translate(-968.761 -412.319)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-2",
    "data-name": "Path 52",
    d: "M973.372,529.268c-2.948,1.485-14.181.46-14.181.46s5.854-9.645,8.8-11.13a5.977,5.977,0,0,1,5.379,10.671Z",
    transform: "translate(-939.711 -468.073)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-2",
    "data-name": "Path 53",
    d: "M967.875,616.406c-2.652,1.961-13.9,2.849-13.9,2.849s4.141-10.494,6.793-12.458a5.977,5.977,0,1,1,7.108,9.61Z",
    transform: "translate(-931.806 -526.89)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17880",
    "data-name": "Group 17880",
    transform: "translate(-474 51.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27-3",
    "data-name": "Path 27",
    d: "M21.757,118.9V88.343H40.129V118.9H61.886V71.63H77.841V36.292H90.9V0h27.075V36.292h13.054V71.63H146.5v-42.5h8.7V7.64h5.318V29.129h30.943V164.748h23.691V150.422h14.5v14.326h23.691V118.9h42.547V88.343h18.373V118.9h.967v58.736h19.339V143.259H357.78v34.382H377.12V71.63h14.988V36.292h55.117V71.63h14.5V258.344H0V118.9Z",
    transform: "translate(0)",
    fill: "#0a1f39"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-3",
    "data-name": "Rectangle 15",
    width: 20.176,
    height: 11.529,
    transform: "translate(432.427 84.289)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-3",
    "data-name": "Rectangle 16",
    width: 20.176,
    height: 11.529,
    transform: "translate(386.572 84.289)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-3",
    "data-name": "Rectangle 17",
    width: 20.176,
    height: 11.529,
    transform: "translate(432.427 107.189)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-3",
    "data-name": "Rectangle 18",
    width: 20.176,
    height: 11.529,
    transform: "translate(386.572 107.189)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19-3",
    "data-name": "Rectangle 19",
    width: 20.176,
    height: 11.529,
    transform: "translate(432.427 130.088)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20-3",
    "data-name": "Rectangle 20",
    width: 20.176,
    height: 11.529,
    transform: "translate(386.572 130.088)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-3",
    "data-name": "Rectangle 21",
    width: 20.176,
    height: 11.529,
    transform: "translate(432.427 152.987)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-3",
    "data-name": "Rectangle 22",
    width: 20.176,
    height: 11.529,
    transform: "translate(386.572 152.987)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-3",
    "data-name": "Rectangle 23",
    width: 20.176,
    height: 11.529,
    transform: "translate(432.427 175.887)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-3",
    "data-name": "Rectangle 24",
    width: 20.176,
    height: 11.529,
    transform: "translate(386.572 175.887)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-3",
    "data-name": "Rectangle 25",
    width: 20.176,
    height: 11.529,
    transform: "translate(432.427 198.786)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26-3",
    "data-name": "Rectangle 26",
    width: 20.176,
    height: 11.529,
    transform: "translate(386.572 198.786)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-3",
    "data-name": "Rectangle 27",
    width: 20.176,
    height: 11.529,
    transform: "translate(432.427 221.529)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28-3",
    "data-name": "Rectangle 28",
    width: 20.176,
    height: 11.529,
    transform: "translate(386.572 221.529)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29-3",
    "data-name": "Rectangle 29",
    width: 47.076,
    height: 5.764,
    transform: "translate(322.412 192.892)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-3",
    "data-name": "Rectangle 30",
    width: 47.076,
    height: 5.764,
    transform: "translate(322.412 201.66)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-3",
    "data-name": "Rectangle 31",
    width: 47.076,
    height: 5.764,
    transform: "translate(322.412 210.171)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-3",
    "data-name": "Rectangle 32",
    width: 47.076,
    height: 5.764,
    transform: "translate(198.668 195.815)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-3",
    "data-name": "Rectangle 33",
    width: 47.076,
    height: 5.764,
    transform: "translate(198.668 204.583)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34-3",
    "data-name": "Rectangle 34",
    width: 47.076,
    height: 5.764,
    transform: "translate(198.668 213.112)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35-3",
    "data-name": "Rectangle 35",
    width: 47.076,
    height: 5.764,
    transform: "translate(322.412 218.992)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36-3",
    "data-name": "Rectangle 36",
    width: 47.076,
    height: 5.764,
    transform: "translate(322.412 227.814)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37-3",
    "data-name": "Rectangle 37",
    width: 47.076,
    height: 5.764,
    transform: "translate(322.412 236.635)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38-3",
    "data-name": "Rectangle 38",
    width: 12.97,
    height: 16.813,
    transform: "translate(291.838 132.555)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39-3",
    "data-name": "Rectangle 39",
    width: 12.97,
    height: 16.813,
    transform: "translate(263.33 132.555)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40-3",
    "data-name": "Rectangle 40",
    width: 12.97,
    height: 16.813,
    transform: "translate(291.838 159.845)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41-3",
    "data-name": "Rectangle 41",
    width: 12.97,
    height: 16.813,
    transform: "translate(263.33 159.846)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42-3",
    "data-name": "Rectangle 42",
    width: 12.97,
    height: 16.813,
    transform: "translate(291.838 187.136)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43-3",
    "data-name": "Rectangle 43",
    width: 12.97,
    height: 16.813,
    transform: "translate(263.33 187.136)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44-3",
    "data-name": "Rectangle 44",
    width: 12.97,
    height: 16.813,
    transform: "translate(291.838 214.255)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45-3",
    "data-name": "Rectangle 45",
    width: 12.97,
    height: 16.813,
    transform: "translate(263.33 214.255)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46-3",
    "data-name": "Rectangle 46",
    width: 17.293,
    height: 22.097,
    transform: "translate(173.952 40.09)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47-3",
    "data-name": "Rectangle 47",
    width: 17.293,
    height: 22.097,
    transform: "translate(173.952 73.118)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48-3",
    "data-name": "Rectangle 48",
    width: 17.293,
    height: 22.097,
    transform: "translate(173.952 105.289)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49-3",
    "data-name": "Rectangle 49",
    width: 17.293,
    height: 22.097,
    transform: "translate(173.952 137.461)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50-3",
    "data-name": "Rectangle 50",
    width: 17.293,
    height: 22.097,
    transform: "translate(173.952 169.633)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51-3",
    "data-name": "Rectangle 51",
    width: 17.293,
    height: 22.097,
    transform: "translate(173.952 201.581)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52-3",
    "data-name": "Rectangle 52",
    width: 64.37,
    height: 18.734,
    transform: "translate(71.335 86.753)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53-3",
    "data-name": "Rectangle 53",
    width: 64.37,
    height: 18.734,
    transform: "translate(71.095 127.693)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54-3",
    "data-name": "Rectangle 54",
    width: 64.37,
    height: 18.734,
    transform: "translate(70.855 168.632)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55-3",
    "data-name": "Rectangle 55",
    width: 64.37,
    height: 18.734,
    transform: "translate(70.614 209.379)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56-3",
    "data-name": "Rectangle 56",
    width: 8.647,
    height: 18.254,
    transform: "translate(438.672 47.275)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57-3",
    "data-name": "Rectangle 57",
    width: 21.617,
    height: 27.861,
    transform: "translate(0 132.623)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58-3",
    "data-name": "Rectangle 58",
    width: 21.617,
    height: 27.861,
    transform: "translate(0 173.58)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59-3",
    "data-name": "Rectangle 59",
    width: 21.617,
    height: 27.861,
    transform: "translate(0 214.43)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-3",
    "data-name": "Path 28",
    d: "M319.2,152.423h3.3a2.315,2.315,0,1,1,0-4.626h26.771a2.315,2.315,0,0,1,0,4.626h-3.3a2.315,2.315,0,1,1,0,4.626H350.6a2.315,2.315,0,1,1,0,4.626H323.827a2.315,2.315,0,1,1,0-4.626H319.2a2.315,2.315,0,1,1,0-4.626Z",
    transform: "translate(14.422 -129.519)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-4",
    "data-name": "Path 29",
    d: "M565.2,273.423h3.3a2.315,2.315,0,1,1,0-4.626h26.771a2.315,2.315,0,0,1,0,4.626h-3.3a2.315,2.315,0,1,1,0,4.626H596.6a2.315,2.315,0,1,1,0,4.626H569.827a2.315,2.315,0,1,1,0-4.626H565.2a2.315,2.315,0,1,1,0-4.626Z",
    transform: "translate(-350.472 -191.297)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-4",
    "data-name": "Path 30",
    d: "M984.2,115.423h3.3a2.315,2.315,0,1,1,0-4.626h26.771a2.315,2.315,0,0,1,0,4.626h-3.305a2.315,2.315,0,1,1,0,4.626h4.626a2.315,2.315,0,1,1,0,4.626H988.827a2.315,2.315,0,0,1,0-4.626H984.2a2.315,2.315,0,1,1,0-4.626Z",
    transform: "translate(-972.039 -110.293)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-4",
    "data-name": "Path 31",
    d: "M518.88,465.94c.37.269.572.418.572.418A2.431,2.431,0,0,1,518.88,465.94Z",
    transform: "translate(-249.581 -292.478)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-4",
    "data-name": "Path 32",
    d: "M519.81,466.88c.37.269.572.418.572.418A2.439,2.439,0,0,1,519.81,466.88Z",
    transform: "translate(-250.96 -292.96)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-4",
    "data-name": "Path 33",
    d: "M519.81,465.94c.37.269.572.418.572.418A2.434,2.434,0,0,1,519.81,465.94Z",
    transform: "translate(-250.96 -292.478)",
    fill: "#ebfaff",
    opacity: 0.253
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17881",
    "data-name": "Group 17881",
    transform: "translate(-1017.206 6.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27-4",
    "data-name": "Path 27",
    d: "M25.6,139.887V103.932H47.211v35.955h25.6V84.269h18.77V42.7h15.358V0h31.853V42.7h15.358V84.269h18.2v-50h10.238V8.989h6.257V34.269h36.4v159.55h27.871V176.965h17.064v16.854h27.871V139.887h50.055V103.932h21.615v35.955h1.138v69.1h22.752V168.538h27.3v40.449h22.752V84.269H461.3V42.7h64.843V84.269h17.064V303.931H0V139.887Z",
    transform: "translate(0)",
    fill: "#0a1f39"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15-4",
    "data-name": "Rectangle 15",
    width: 23.736,
    height: 13.563,
    transform: "translate(508.733 99.163)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-4",
    "data-name": "Rectangle 16",
    width: 23.736,
    height: 13.563,
    transform: "translate(454.786 99.163)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-4",
    "data-name": "Rectangle 17",
    width: 23.736,
    height: 13.563,
    transform: "translate(508.733 126.103)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-4",
    "data-name": "Rectangle 18",
    width: 23.736,
    height: 13.563,
    transform: "translate(454.786 126.103)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19-4",
    "data-name": "Rectangle 19",
    width: 23.736,
    height: 13.563,
    transform: "translate(508.733 153.043)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20-4",
    "data-name": "Rectangle 20",
    width: 23.736,
    height: 13.563,
    transform: "translate(454.786 153.043)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21-4",
    "data-name": "Rectangle 21",
    width: 23.736,
    height: 13.563,
    transform: "translate(508.733 179.983)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22-4",
    "data-name": "Rectangle 22",
    width: 23.736,
    height: 13.563,
    transform: "translate(454.786 179.983)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23-4",
    "data-name": "Rectangle 23",
    width: 23.736,
    height: 13.563,
    transform: "translate(508.733 206.923)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24-4",
    "data-name": "Rectangle 24",
    width: 23.736,
    height: 13.563,
    transform: "translate(454.786 206.923)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-4",
    "data-name": "Rectangle 25",
    width: 23.736,
    height: 13.563,
    transform: "translate(508.733 233.863)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26-4",
    "data-name": "Rectangle 26",
    width: 23.736,
    height: 13.563,
    transform: "translate(454.786 233.864)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27-4",
    "data-name": "Rectangle 27",
    width: 23.736,
    height: 13.563,
    transform: "translate(508.733 260.62)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28-4",
    "data-name": "Rectangle 28",
    width: 23.736,
    height: 13.563,
    transform: "translate(454.786 260.62)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29-4",
    "data-name": "Rectangle 29",
    width: 55.383,
    height: 6.782,
    transform: "translate(379.304 226.929)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-4",
    "data-name": "Rectangle 30",
    width: 55.383,
    height: 6.782,
    transform: "translate(379.304 237.245)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31-4",
    "data-name": "Rectangle 31",
    width: 55.383,
    height: 6.782,
    transform: "translate(379.304 247.258)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32-4",
    "data-name": "Rectangle 32",
    width: 55.383,
    height: 6.782,
    transform: "translate(233.724 230.368)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33-4",
    "data-name": "Rectangle 33",
    width: 55.383,
    height: 6.782,
    transform: "translate(233.724 240.683)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34-4",
    "data-name": "Rectangle 34",
    width: 55.383,
    height: 6.782,
    transform: "translate(233.724 250.717)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35-4",
    "data-name": "Rectangle 35",
    width: 55.383,
    height: 6.782,
    transform: "translate(379.304 257.635)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36-4",
    "data-name": "Rectangle 36",
    width: 55.383,
    height: 6.782,
    transform: "translate(379.304 268.013)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37-4",
    "data-name": "Rectangle 37",
    width: 55.383,
    height: 6.782,
    transform: "translate(379.304 278.391)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38-4",
    "data-name": "Rectangle 38",
    width: 15.259,
    height: 19.78,
    transform: "translate(343.335 155.945)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39-4",
    "data-name": "Rectangle 39",
    width: 15.259,
    height: 19.78,
    transform: "translate(309.797 155.946)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40-4",
    "data-name": "Rectangle 40",
    width: 15.259,
    height: 19.78,
    transform: "translate(343.335 188.052)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41-4",
    "data-name": "Rectangle 41",
    width: 15.259,
    height: 19.78,
    transform: "translate(309.797 188.052)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42-4",
    "data-name": "Rectangle 42",
    width: 15.259,
    height: 19.78,
    transform: "translate(343.335 220.158)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43-4",
    "data-name": "Rectangle 43",
    width: 15.259,
    height: 19.78,
    transform: "translate(309.797 220.158)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44-4",
    "data-name": "Rectangle 44",
    width: 15.259,
    height: 19.78,
    transform: "translate(343.335 252.062)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45-4",
    "data-name": "Rectangle 45",
    width: 15.259,
    height: 19.78,
    transform: "translate(309.797 252.062)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46-4",
    "data-name": "Rectangle 46",
    width: 20.345,
    height: 25.996,
    transform: "translate(204.647 47.165)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47-4",
    "data-name": "Rectangle 47",
    width: 20.345,
    height: 25.996,
    transform: "translate(204.647 86.02)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48-4",
    "data-name": "Rectangle 48",
    width: 20.345,
    height: 25.996,
    transform: "translate(204.647 123.869)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49-4",
    "data-name": "Rectangle 49",
    width: 20.345,
    height: 25.996,
    transform: "translate(204.647 161.717)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50-4",
    "data-name": "Rectangle 50",
    width: 20.345,
    height: 25.996,
    transform: "translate(204.647 199.566)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51-4",
    "data-name": "Rectangle 51",
    width: 20.345,
    height: 25.996,
    transform: "translate(204.647 237.151)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52-4",
    "data-name": "Rectangle 52",
    width: 75.728,
    height: 22.04,
    transform: "translate(83.923 102.061)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53-4",
    "data-name": "Rectangle 53",
    width: 75.728,
    height: 22.04,
    transform: "translate(83.641 150.225)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54-4",
    "data-name": "Rectangle 54",
    width: 75.728,
    height: 22.04,
    transform: "translate(83.357 198.389)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55-4",
    "data-name": "Rectangle 55",
    width: 75.728,
    height: 22.04,
    transform: "translate(83.075 246.326)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56-4",
    "data-name": "Rectangle 56",
    width: 10.172,
    height: 21.475,
    transform: "translate(516.08 55.617)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57-4",
    "data-name": "Rectangle 57",
    width: 25.431,
    height: 32.778,
    transform: "translate(0 156.025)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58-4",
    "data-name": "Rectangle 58",
    width: 25.431,
    height: 32.778,
    transform: "translate(0 204.209)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59-4",
    "data-name": "Rectangle 59",
    width: 25.431,
    height: 32.778,
    transform: "translate(0 252.269)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-4",
    "data-name": "Path 28",
    d: "M319.629,153.24h3.888a2.724,2.724,0,1,1,0-5.442h31.5a2.724,2.724,0,0,1,0,5.442h-3.888a2.724,2.724,0,1,1,0,5.442h5.442a2.724,2.724,0,1,1,0,5.442h-31.5a2.724,2.724,0,1,1,0-5.442h-5.442a2.724,2.724,0,1,1,0-5.442Z",
    transform: "translate(72.866 -126.294)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-5",
    "data-name": "Path 29",
    d: "M565.628,274.24h3.888a2.724,2.724,0,1,1,0-5.442h31.5a2.724,2.724,0,0,1,0,5.442h-3.888a2.724,2.724,0,1,1,0,5.442h5.442a2.724,2.724,0,1,1,0,5.442H571.071a2.724,2.724,0,1,1,0-5.442h-5.443a2.724,2.724,0,1,1,0-5.442Z",
    transform: "translate(-313.008 -177.622)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-5",
    "data-name": "Path 30",
    d: "M984.629,116.24h3.888a2.724,2.724,0,1,1,0-5.442h31.5a2.724,2.724,0,0,1,0,5.442h-3.888a2.724,2.724,0,1,1,0,5.442h5.442a2.724,2.724,0,1,1,0,5.442H990.071a2.724,2.724,0,0,1,0-5.442h-5.442a2.724,2.724,0,1,1,0-5.442Z",
    transform: "translate(-970.319 -110.204)",
    fill: "#ebfaff",
    opacity: 0.247
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-5",
    "data-name": "Path 31",
    d: "M518.88,465.94c.435.317.672.492.672.492A2.86,2.86,0,0,1,518.88,465.94Z",
    transform: "translate(-202.061 -261.869)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-5",
    "data-name": "Path 32",
    d: "M519.81,466.88c.435.316.673.492.673.492A2.871,2.871,0,0,1,519.81,466.88Z",
    transform: "translate(-203.519 -262.27)",
    fill: "#ebfaff",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-5",
    "data-name": "Path 33",
    d: "M519.81,465.94c.435.317.673.492.673.492A2.865,2.865,0,0,1,519.81,465.94Z",
    transform: "translate(-203.519 -261.869)",
    fill: "#ebfaff",
    opacity: 0.253
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17882",
    "data-name": "Group 17882",
    transform: "translate(-1221.589 235.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-6",
    "data-name": "Path 29",
    d: "M155.6,584.046s-17.547,10.587,14.8,26.886c0,0,7.132-13.23-.753-24.018a10.623,10.623,0,0,0-13.781-3.02Z",
    transform: "translate(-150.851 -537.558)",
    fill: "#01a09b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-6",
    "data-name": "Path 30",
    d: "M173.08,588.3s15.015,11.49,14.6,27.109",
    transform: "translate(-167.877 -542.034)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-6",
    "data-name": "Path 31",
    d: "M234.683,504.82s-5.5-18.669,1.032-32.409a29.48,29.48,0,0,0,2.385-18.5,49.593,49.593,0,0,0-2.619-8.692",
    transform: "translate(-214 -430.844)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-6",
    "data-name": "Path 32",
    d: "M235.1,391.528c0,2.289-4.143,8.915-4.143,8.915s-4.143-6.635-4.143-8.915a4.143,4.143,0,1,1,8.284,0Z",
    transform: "translate(-209.572 -387.289)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-6",
    "data-name": "Path 33",
    d: "M265.727,441.169c-1.244,1.921-8.327,5.238-8.327,5.238s.129-7.821,1.373-9.742a4.143,4.143,0,0,1,6.954,4.5Z",
    transform: "translate(-233.299 -424.045)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34-2",
    "data-name": "Path 34",
    d: "M259.131,532.995c-2.044,1.03-9.831.319-9.831.319s4.059-6.686,6.1-7.716a4.143,4.143,0,1,1,3.731,7.4Z",
    transform: "translate(-227.01 -493.826)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-2",
    "data-name": "Path 35",
    d: "M242.237,607.568c-1.839,1.36-9.637,1.975-9.637,1.975s2.871-7.275,4.709-8.637a4.143,4.143,0,1,1,4.928,6.662Z",
    transform: "translate(-214.056 -551.695)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36-2",
    "data-name": "Path 36",
    d: "M213.747,463.606c1.64,1.594,9.287,3.245,9.287,3.245s-1.872-7.594-3.513-9.189a4.143,4.143,0,1,0-5.773,5.942Z",
    transform: "translate(-198.402 -440.711)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37-2",
    "data-name": "Path 37",
    d: "M190.957,547.285c2.044,1.03,9.831.319,9.831.319s-4.059-6.686-6.1-7.716a4.143,4.143,0,1,0-3.731,7.4Z",
    transform: "translate(-179.979 -504.864)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38-2",
    "data-name": "Path 38",
    d: "M185.6,634.729c1.839,1.359,9.637,1.975,9.637,1.975s-2.871-7.277-4.712-8.637a4.143,4.143,0,1,0-4.928,6.662Z",
    transform: "translate(-176.286 -572.306)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-2",
    "data-name": "Path 39",
    d: "M235.1,391.528c0,2.289-4.143,8.915-4.143,8.915s-4.143-6.635-4.143-8.915a4.143,4.143,0,1,1,8.284,0Z",
    transform: "translate(-209.572 -387.289)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-2",
    "data-name": "Path 40",
    d: "M265.727,441.169c-1.244,1.921-8.327,5.238-8.327,5.238s.129-7.821,1.373-9.742a4.143,4.143,0,0,1,6.954,4.5Z",
    transform: "translate(-233.299 -424.045)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41-2",
    "data-name": "Path 41",
    d: "M259.131,532.995c-2.044,1.03-9.831.319-9.831.319s4.059-6.686,6.1-7.716a4.143,4.143,0,1,1,3.731,7.4Z",
    transform: "translate(-227.01 -493.826)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42-2",
    "data-name": "Path 42",
    d: "M242.237,607.568c-1.839,1.36-9.637,1.975-9.637,1.975s2.871-7.275,4.709-8.637a4.143,4.143,0,1,1,4.928,6.662Z",
    transform: "translate(-214.056 -551.695)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43-2",
    "data-name": "Path 43",
    d: "M213.747,463.606c1.64,1.594,9.287,3.245,9.287,3.245s-1.872-7.594-3.513-9.189a4.143,4.143,0,1,0-5.773,5.942Z",
    transform: "translate(-198.402 -440.711)",
    fill: "#5ec5c1",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44-2",
    "data-name": "Path 44",
    d: "M190.957,547.285c2.044,1.03,9.831.319,9.831.319s-4.059-6.686-6.1-7.716a4.143,4.143,0,1,0-3.731,7.4Z",
    transform: "translate(-179.979 -504.864)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45-2",
    "data-name": "Path 45",
    d: "M185.6,634.729c1.839,1.359,9.637,1.975,9.637,1.975s-2.871-7.277-4.712-8.637a4.143,4.143,0,1,0-4.928,6.662Z",
    transform: "translate(-176.286 -572.306)",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17883",
    "data-name": "Group 17883",
    transform: "translate(-1132.639 210.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-3",
    "data-name": "Path 46",
    d: "M1005.459,503.173s-7.342-24.927,1.378-43.275a39.363,39.363,0,0,0,3.184-24.7,66.228,66.228,0,0,0-3.5-11.607",
    transform: "translate(-988.107 -404.254)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-3",
    "data-name": "Path 47",
    d: "M1007.971,371.321c0,3.056-5.532,11.9-5.532,11.9s-5.533-8.86-5.533-11.9a5.533,5.533,0,1,1,11.062,0Z",
    transform: "translate(-984.128 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-3",
    "data-name": "Path 48",
    d: "M1038.569,421.106c-1.661,2.565-11.119,6.994-11.119,6.994s.173-10.443,1.833-13.008a5.532,5.532,0,1,1,9.285,6.012Z",
    transform: "translate(-1005.583 -398.241)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-3",
    "data-name": "Path 49",
    d: "M1032.487,513.994c-2.729,1.375-13.128.426-13.128.426s5.419-8.928,8.148-10.3a5.532,5.532,0,1,1,4.982,9.879Z",
    transform: "translate(-999.901 -461.689)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-3",
    "data-name": "Path 50",
    d: "M1015.528,588.444c-2.455,1.815-12.868,2.637-12.868,2.637s3.833-9.714,6.288-11.532a5.532,5.532,0,1,1,6.58,8.9Z",
    transform: "translate(-988.171 -513.835)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-3",
    "data-name": "Path 51",
    d: "M984.461,444.575c2.19,2.128,12.4,4.333,12.4,4.333s-2.5-10.139-4.69-12.27a5.533,5.533,0,1,0-7.711,7.937Z",
    transform: "translate(-974.209 -414.009)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-3",
    "data-name": "Path 52",
    d: "M962.11,528.432c2.729,1.375,13.128.426,13.128.426s-5.42-8.928-8.149-10.3a5.533,5.533,0,0,0-4.979,9.878Z",
    transform: "translate(-957.638 -471.784)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-3",
    "data-name": "Path 53",
    d: "M956.216,615.6c2.455,1.815,12.869,2.637,12.869,2.637s-3.833-9.714-6.289-11.532a5.532,5.532,0,1,0-6.58,8.9Z",
    transform: "translate(-953.974 -532.741)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17884",
    "data-name": "Group 17884",
    transform: "translate(-1234.503 245.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54-2",
    "data-name": "Path 54",
    d: "M899.232,591.006s4.783-16.233-.9-28.187a25.645,25.645,0,0,1-2.074-16.089,43.131,43.131,0,0,1,2.276-7.55",
    transform: "translate(-887.461 -526.455)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55-2",
    "data-name": "Path 55",
    d: "M892.72,511.837c0,1.991,3.607,7.759,3.607,7.759s3.607-5.772,3.607-7.759a3.607,3.607,0,1,0-7.215,0Z",
    transform: "translate(-885.177 -508.23)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56-2",
    "data-name": "Path 56",
    d: "M909.822,538.682c1.082,1.67,7.243,4.556,7.243,4.556s-.112-6.8-1.194-8.474a3.607,3.607,0,1,0-6.049,3.917Z",
    transform: "translate(-908.234 -523.881)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57-2",
    "data-name": "Path 57",
    d: "M906.647,589.033c1.778.895,8.553.278,8.553.278s-3.531-5.815-5.306-6.71a3.607,3.607,0,0,0-3.247,6.435Z",
    transform: "translate(-904.8 -555.078)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58-2",
    "data-name": "Path 58",
    d: "M897.144,629.048c1.6,1.183,8.383,1.717,8.383,1.717s-2.5-6.327-4.1-7.51a3.607,3.607,0,0,0-4.286,5.793Z",
    transform: "translate(-891.888 -579.814)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-2",
    "data-name": "Path 59",
    d: "M892.879,551.314c-1.443,1.385-8.077,2.824-8.077,2.824s1.627-6.6,3.055-7.99a3.607,3.607,0,1,1,5.021,5.169Z",
    transform: "translate(-876.484 -531.497)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60-2",
    "data-name": "Path 60",
    d: "M881.153,596.723c-1.778.895-8.553.278-8.553.278s3.532-5.815,5.306-6.71a3.607,3.607,0,0,1,3.247,6.435Z",
    transform: "translate(-860.985 -559.937)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61-2",
    "data-name": "Path 61",
    d: "M878.36,643.62c-1.6,1.183-8.383,1.717-8.383,1.717s2.511-6.331,4.1-7.514a3.607,3.607,0,0,1,4.285,5.8Z",
    transform: "translate(-856.749 -589.116)",
    fill: "#017572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17885",
    "data-name": "Group 17885",
    transform: "translate(-1154.464 243.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-4",
    "data-name": "Path 46",
    d: "M1006.16,477.4s4.964-16.854-.932-29.258a26.613,26.613,0,0,1-2.153-16.7,44.781,44.781,0,0,1,2.364-7.847",
    transform: "translate(-993.8 -410.517)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-4",
    "data-name": "Path 47",
    d: "M996.9,369.487c0,2.066,3.74,8.049,3.74,8.049s3.741-5.99,3.741-8.049a3.741,3.741,0,1,0-7.479,0Z",
    transform: "translate(-988.934 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-4",
    "data-name": "Path 48",
    d: "M1028.1,418.3c1.123,1.734,7.517,4.729,7.517,4.729s-.117-7.061-1.24-8.8a3.741,3.741,0,1,0-6.278,4.065Z",
    transform: "translate(-1026.313 -402.843)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-4",
    "data-name": "Path 49",
    d: "M1021.419,510.6c1.845.93,8.876.288,8.876.288s-3.664-6.036-5.509-6.966a3.74,3.74,0,1,0-3.369,6.679Z",
    transform: "translate(-1019.36 -475.238)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-4",
    "data-name": "Path 50",
    d: "M1004.176,585.212c1.66,1.227,8.7,1.783,8.7,1.783s-2.592-6.568-4.252-7.8a3.741,3.741,0,1,0-4.449,6.014Z",
    transform: "translate(-998.582 -534.768)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-4",
    "data-name": "Path 51",
    d: "M991.168,441.5c-1.481,1.439-8.385,2.93-8.385,2.93s1.69-6.855,3.171-8.3a3.741,3.741,0,1,1,5.213,5.366Z",
    transform: "translate(-974.007 -420.832)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-4",
    "data-name": "Path 52",
    d: "M968.067,525.061c-1.845.93-8.875.288-8.875.288s3.664-6.036,5.509-6.966a3.741,3.741,0,0,1,3.366,6.678Z",
    transform: "translate(-946.999 -486.761)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-4",
    "data-name": "Path 53",
    d: "M962.674,612.372c-1.66,1.227-8.7,1.783-8.7,1.783s2.592-6.568,4.252-7.8a3.74,3.74,0,1,1,4.449,6.014Z",
    transform: "translate(-940.099 -556.347)",
    fill: "#017572"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPageBuilding);
export default __webpack_public_path__ + "static/media/error-page-building.c81f338298d4b272f614f237b975b6cb.svg";
export { ForwardRef as ReactComponent };